import { createTheme } from '@mui/material/styles';

// Material Design Theme Configuration
// Following Material Design 3 principles with DC legal aesthetic
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Material Blue 700
      light: '#4791db',
      dark: '#115293',
    },
    secondary: {
      main: '#dc004e', // Material Pink A400
      light: '#e33371',
      dark: '#9a0036',
    },
    background: {
      default: '#f5f5f5', // Material Grey 100
      paper: '#ffffff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    success: {
      main: '#2e7d32', // Material Green 800
    },
    error: {
      main: '#d32f2f', // Material Red 700
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Oxygen',
      'Ubuntu',
      'Cantarell',
      'Fira Sans',
      'Droid Sans',
      'Helvetica Neue',
      'sans-serif',
    ].join(','),
    h4: {
      fontWeight: 600,
      letterSpacing: '-0.5px',
    },
    h5: {
      fontWeight: 500,
      letterSpacing: '0px',
    },
    h6: {
      fontWeight: 500,
      letterSpacing: '0.15px',
    },
    button: {
      textTransform: 'none', // More modern, less shouty
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8, // Softer corners per Material Design 3
  },
  spacing: 8, // 8dp grid system
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14)',
          },
        },
        contained: {
          '&:hover': {
            boxShadow: '0px 4px 8px -2px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
        elevation3: {
          boxShadow: '0px 3px 6px rgba(0,0,0,0.1), 0px 2px 4px rgba(0,0,0,0.06)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginBottom: 4,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        },
      },
    },
  },
});

export default theme;
